import React, { Component } from 'react'

import FooterMenu from '../menu/FooterMenu'
import Menu from '../Menu'
import LoadingSpinner from '../LoadingSpinner'
import ChannelMenuItem from '../present/ChannelMenuItem'

export default class PlaylistMenu extends Component {
  state = {
    channels: null,
    presentMenu: false,
    playNowMenu: false,
    playNextMenu: false,
    presenting: false
  }
  getPresentMenuItems () {
    const { playNowMenu, channels } = this.state
    if (!channels) {
      return [{ text: <LoadingSpinner /> }]
    }
    const items = [{
      text: playNowMenu ? 'Present on this device' : 'New channel (auto-generated)',
      onClick: () => this.onAddToChannel({}, playNowMenu) // Empty channel to cause auto-generation
    }]
    return items.concat(channels.map(channel => ({
      key: channel.id,
      text: <ChannelMenuItem channel={channel} />,
      onClick: () => this.onAddToChannel(channel, playNowMenu)
    })))
  }
  onAddToChannel = (channel, playNow) => {
    const { id, sendToPlayNow, sendToPlayNext, showBanner } = this.props
    const success = data => {
      if (!channel.id && playNow) {
        this.props.presentChannel(data.channel)
      } else {
        showBanner('Playlist added to channel')
      }
    }
    if (playNow || !channel.id) {
      sendToPlayNow(channel.id, { playlist_id: id }).then(success)
    } else {
      sendToPlayNext(channel.id, { playlist_id: id }).then(success)
    }
  }
  render () {
    const { structure, fetchChannels } = this.props
    const { presentMenu, playNowMenu, playNextMenu, presenting } = this.state

    const presentMenuItems = this.getPresentMenuItems()

    return (
      <div>
        {/*
        <FooterMenu
          items={[
            {
              icon: 'bars',
              onClick: () => this.setState({ presentMenu: true })
            }
          ]}
        />
        */}
        <Menu
          open={presentMenu}
          closeMenu={() => this.setState({ presentMenu: false })}
          items={[
            {
              text: 'Play now',
              onClick: () => {
                this.setState({
                  channels: null,
                  playNowMenu: true
                })
                fetchChannels().then(channels => this.setState({ channels }))
              }
            },
            {
              text: 'Play next',
              onClick: () => {
                this.setState({
                  channels: null,
                  playNextMenu: true
                })
                fetchChannels().then(channels => this.setState({ channels }))
              }
            }
          ]}
        />
        <Menu
          open={playNowMenu}
          closeMenu={() => this.setState({ playNowMenu: false })}
          items={presentMenuItems}
        />
        <Menu
          open={playNextMenu}
          closeMenu={() => this.setState({ playNextMenu: false })}
          items={presentMenuItems}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/playlist/PlaylistMenu.js